import React from "react";
import { Select, Form } from "antd";
import { FormInstance, Rule } from "antd/es/form";

interface SearchSelectedProps {
  title: string;
  options: any[];
  onChange: (value: any) => void;
  id: string;
  form?: FormInstance<any>;
  labelCol?: { span: number };
  initialValue?: number;
  disabled?: boolean;
  value?: any;
  rules?: Rule[];
  bordered?: boolean;
  className?: string;
  loading?: boolean;
  mode?: "multiple" | "tags";
}

const SearchSelected: React.FC<SearchSelectedProps> = ({
  title,
  options,
  onChange,
  id,
  form,
  labelCol = { span: 8 },
  initialValue,
  disabled = false,
  value,
  rules = [],
  bordered = true,
  className = "",
  loading = false,
  mode,
}) => {
  // const defaultValue =
  //   initialValue || (mode === "multiple" ? [] : options?.[0]?.value);

  return (
    <Form.Item
      label={title}
      labelCol={labelCol}
      name={id}
      // initialValue={defaultValue}
      rules={rules}
      className={className}
    >
      <Select
        mode={mode}
        loading={loading}
        showSearch
        allowClear
        bordered={bordered}
        placeholder={title}
        onChange={(value) => {
          onChange(value);
        }}
        autoClearSearchValue={true}
        disabled={disabled}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={options}
        value={value}
      />
    </Form.Item>
  );
};

export default SearchSelected;
